import { LandingBlock, SavedComponent } from '../types'
import { supabase } from './supabaseClient'
import { getDb, refresh } from './store'
import { newId } from './authService'

/** Biblioteca de componentes reutilizables de cada empresa. */
export function listComponents(organizationId: string): SavedComponent[] {
  return getDb()
    .components.filter((c) => c.organizationId === organizationId)
    .sort((a, b) => b.createdAt.localeCompare(a.createdAt))
}

export async function saveComponent(
  organizationId: string,
  name: string,
  category: string,
  block: LandingBlock,
): Promise<void> {
  const { data } = await supabase.auth.getUser()
  const { error } = await supabase.from('component_library').insert({
    organization_id: organizationId,
    name,
    type: category,
    content: JSON.parse(JSON.stringify(block)),
    style: { block: block.style ?? null, button: block.button ?? null },
    created_by: data.user?.id ?? null,
  })
  if (error) throw new Error(error.message)
  await refresh()
}

export async function deleteComponent(componentId: string): Promise<void> {
  const { error } = await supabase
    .from('component_library')
    .delete()
    .eq('id', componentId)
  if (error) throw new Error(error.message)
  await refresh()
}

/** Devuelve una copia del bloque guardado, lista para insertar en una landing. */
export function instantiateComponent(component: SavedComponent): LandingBlock {
  return {
    ...JSON.parse(JSON.stringify(component.block)),
    id: newId('block'),
  } as LandingBlock
}
